import {
  GET_QUOTA_REQUEST,
  GET_QUOTA_SUCCESS,
  GET_QUOTA_ERROR,
  OPEN_QUOTA_MODAL,
  CLOSE_QUOTA_MODAL,
} from "../constants/actionTypes";

const initialState = {
  quota: [],
  showQuotaModal: false,
  modalContent: "",
};
const Quota = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_QUOTA_REQUEST:
      return {
        ...state,
      };
    case GET_QUOTA_SUCCESS:
      return {
        ...state,
        quota: payload.data.data,
      };
    case GET_QUOTA_ERROR:
      return {
        ...state,
      };

    case OPEN_QUOTA_MODAL:
      return {
        ...state,
        showQuotaModal: true,
        modalContent: payload,
      };
    case CLOSE_QUOTA_MODAL:
      return {
        ...state,
        showQuotaModal: false,
      };

    default:
      return { ...state };
  }
};

export default Quota;
